export default {
      id: "pdf-usage",
      viewBox: "0 0 22 25",
      url: __webpack_public_path__ + "img/icons.df848786.svg#pdf",
      toString: function () {
        return this.url;
      }
    }